<template>
    <div class="">
        <h3>{{ title }}</h3>
        <!-- for the width: -->
        <!-- - 230 refers to the size of the sidebar -->
        <!-- - 90 refers to the margin of the simple-layout ( 0 15px ) + the padding of the .graphs-container ( 0 30px ) -->
        <graph-bar
            v-if="values.length > 0"
            :key="totalValues"
            :width="$store.getters.windowWidth - 230 - 90"
            :height="400"
            :axis-min="0"
            :axis-max="max"
            :axisStep="max < 10 ? max : 10"
            :labels="labels"
            :values="values"
            :colors="colors"
            theme="dark"
            :fixedSize="barSize"
        >
            <tooltip :names="names" :position="'left'"></tooltip>
            <legends :names="names"></legends>
        </graph-bar>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        values: {
            type: Array,
            required: true
        },
        max: {
            type: Number,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        labels: {
            type: Array,
            required: true
        },
        names: {
            type: Array,
            required: true
        },
        colors: {
            type: Array,
            required: true,
        },
    },

    data: function(){
        return {

        };
    },

    computed: {
        totalValues() {
            let valueNumber = 0;
            this.values.forEach(valueArray => {
                valueNumber += valueArray.length;
            });
            return valueNumber;
        },
        barSize() {
            let graphWidth = this.$store.getters.windowWidth - 230 - 90 - 100;
            // width - sidebar - view padding - graph main rect spacing
            let columnPadding = 0;
            this.values.forEach((valueArray, index) => {
                if (index > 0) {
                    columnPadding += 5;
                }
            });
            return graphWidth / this.totalValues - columnPadding;
        }
    },


    methods: {
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Consumption/graph.vue